module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0019.jpg?v=ea69d04b";